import React from "react";
import PremiumDateRangePicker from "../PremiumDateRangePicker";

type DateRange = {
  startDate: string;
  endDate: string;
};

interface DateRangeInputProps {
  title?: string;
  name: string;
  disabled?: boolean;
  isEditable?: boolean;
  value?: DateRange;
  onChange?: (range: DateRange) => void;
  placeholder?: string;
  register?: any;
  error?: any;
  validation?: any;
  inputClassName?: string;
  className?: string;
  labelClass?: string;
  align?: "left" | "right";
}

const DateRangeInput: React.FC<DateRangeInputProps> = ({
  title = "Start & Exp. Date",
  disabled = false,
  isEditable = true,
  value = { startDate: "", endDate: "" },
  onChange,
  error,
  className = "",
  placeholder = "YYYY-MM-DD",
  align = "left",
}) => {
  return (
    <div className={`w-full ${className}`}>
      <PremiumDateRangePicker
        title={title}
        startDate={value?.startDate || ""}
        endDate={value?.endDate || ""}
        startDateError={error}
        endDateError={error}
        disabled={disabled}
        isEditable={isEditable}
        onChangeRange={(newRange) => {
          onChange?.(newRange);
        }}
        placeholder={placeholder}
        align={align}
      />
    </div>
  );
};

export default DateRangeInput;
